import { oz } from '@weft/utils';
import { IntegrationProvidersSchema } from './integration-providers-schema';

export const ConnectedIntegrationsSchema = oz.array(IntegrationProvidersSchema).openapi('ConnectedIntegrations');

export type ConnectedIntegrations = oz.infer<typeof ConnectedIntegrationsSchema>;